/**
 * API Configuration
 * Centralized configuration for backend URL and API settings.
 * 
 * The BACKEND_URL is resolved in the following order:
 * 1. Build-time defined __BACKEND_URL__ (set via BACKEND_URL env var during build)
 * 2. Fallback to production URL
 * 
 * For local development:
 * - Create a .env.dev file in the frontend directory with: BACKEND_URL=http://localhost:8000
 * - Run: bun run dev (which uses --env-file=.env.dev)
 */

declare const __BACKEND_URL__: string | undefined;

const resolveBackendUrl = (): string => {
  // Build-time defined value (from BACKEND_URL env var)
  if (typeof __BACKEND_URL__ !== 'undefined' && __BACKEND_URL__) {
    return __BACKEND_URL__;
  }

  // Default to localhost for development
  return 'http://localhost:8000';
};

export const BACKEND_URL = resolveBackendUrl();
export const API_VERSION = '/api/v1';
export const API_BASE_URL = `${BACKEND_URL}${API_VERSION}`;


